module.exports = __webpack_public_path__ + "static/media/search.977d3468.svg";